import { Pipe, PipeTransform } from '@angular/core';

import { ClienteUnidadeNegocioSearchMercado } from '../cliente-unidade-negocio-search-mercado';

@Pipe({
    name: 'clienteUnidadeNegocioMercadoSituacaoFilter',
    pure: false
})
export class ClienteUnidadeNegocioMercadoSituacaoFilterPipe implements PipeTransform {
    /** Filtra os mercados do cliente pela situação informada */
    transform(entities: ClienteUnidadeNegocioSearchMercado[], situacao: number = null): ClienteUnidadeNegocioSearchMercado[] {
        if (!entities) {
            return [];
        }
        // Retorna todos os mercados quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.situacaoMercado === situacao);
    }
}
